import { Navigate, useParams } from 'react-router-dom';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveCausalIncidente } from '../../shared/components/SaveCausalIncidente';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import { useGetCausalIncidencia } from '@/shared/actions/erp/causal-incidentes';

export interface ActCausalIncidentePageInterface {}

const ActCausalIncidentePage: React.FC<ActCausalIncidentePageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_categoria_producto)

  const { id } = useParams();
  const { data, isLoading } = useGetCausalIncidencia(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_causal_incidencia) return <Navigate to="/tickets-soporte-cliente/causal-incidente" />;

  return <SaveCausalIncidente titlePage="Editar Causal Incidencia" editCausalIncidencia={data.data} />;
};

export default ActCausalIncidentePage;
